import { useState, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";

import { API_URL, translate } from "./utils";
import useFetch from "./utils/useFetch";

import Alert from "./components/Alert";

import Home from "./pages/JuniorGolfSeries/Home";
import Receipt from "./pages/JuniorGolfSeries/Receipt";

/*
  Stripe.setPublishableKey('pk_test_3ctgdNDZHsLr2cbkOHmZfxCz'); // test publishable key
  Stripe.setPublishableKey('pk_live_pzRQTFEdAFpsr4KFrAe7kbAK'); // live publishable key
*/
const stripePromise = loadStripe("pk_live_pzRQTFEdAFpsr4KFrAe7kbAK");

export default function JuniorGolfSeries({ lang, closed = false }) {
	const [events, setEvents] = useState([]);
	const [id, setId] = useState("");
	const [status, setStatus] = useState(closed ? 3 : 2);
	/*
    0 - error
    1 - registration & payment submitted successfully
    2 - not yet started
    3 - closed
  */

	const handleStatus = (id = "", status) => {
		setId(id);
		setStatus(status);
	};

	const [url, setUrl] = useState(null);
	const { loading, data } = useFetch(url);

	useEffect(() => {
		const newUrl = new URL(`${API_URL}/jgsHomeInit`);
		const params = {
			lang,
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setEvents(data.events);
		}
	}, [data]);

	/*
		text: translate(
			lang,
			"Registration will open at 6:00 am tomorrow.",
			"El registro abrirá mañana las 6:00 am PT.",
		),
	*/

	return (
		<>
			{loading ? (
				<div />
			) : status === 3 || events.length === 0 ? (
				<Alert
					data={{
						type: "error",
						text: translate(
							lang,
							"Los Cabos Junior Golf Series registration is now closed.",
							"El registro para el Los Cabos Junior Golf Series ha concluido.",
						),
					}}
				/>
			) : id && status === 1 ? (
				<Receipt id={id} lang={lang} />
			) : (
				<Home status={handleStatus} stripePromise={stripePromise} lang={lang} />
			)}
		</>
	);
}
